import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';

function Logo({
  href = '/', src = '', title = '', width = 0, heigth = 0,
}) {
  if (!width || !heigth) {
    return <span className="fs-4">{title}</span>;
  }

  const ratio = width / heigth;
  const isSquareLogo = Math.floor(ratio) === 1;

  let resizedHeight = 44;
  let resizedWidth = resizedHeight * ratio;

  if (resizedWidth > 200) {
    resizedWidth = 200;
    resizedHeight = resizedWidth / ratio;
  }

  return (
    <Link href={href} className="text-decoration-none text-body d-flex align-items-center">
      {src && (
        <Image src={src} width={resizedWidth} height={resizedHeight} alt={title} />
      )}
      {(!src || isSquareLogo) && <span className="fs-4 ms-2">{title}</span>}
    </Link>
  );
}

Logo.propTypes = {
  href: PropTypes.string,
  src: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.number,
  heigth: PropTypes.number,
};

export default Logo;
